/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CustomerTransactionDetailResponse } from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class MobileApiActivityController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags mobile-api-activity-controller
   * @name GetActivity1
   * @request GET:/api/m/activities/detail/{flowId}
   */
  getActivity = (flowId: string, params: RequestParams = {}) =>
    this.http.request<CustomerTransactionDetailResponse, any>({
      path: `/m/activities/detail/${flowId}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getActivityPath = '/m/activities/detail/${flowId}'
  static getActivityMethod = 'GET'
}
